import axios_instance from './liveChatAxiosInst';

async function setMessageIsReadingState ( 
        id,
        dispatch,
        state,
    ) {
    await axios_instance.post(
        process.env.REACT_APP_LIVE_CHAT_API,
        {
            action: "setReadingStateAdmin",
            message_id: id,
            limit: state.com_offset,
            pseudo: state.pseudo,
        },
    )
    .then (resp => {
        if (resp.status === 200) {
            dispatch({
                type: 'change_active_communication',
                payload: {active_communication: resp.data.activeCom}
            });
        } else {
            dispatch({
                type: 'change_active_communication',
                payload: {active_communication: []}
            });
        }
    })
    .catch (() => { console.log('pas 200')
        dispatch({
            type: 'change_active_communication',
            payload: {active_communication: []}
        })}
    )
}

export default setMessageIsReadingState;